<button name="copyTaxYear"
        class="ws-flex-none ace-btn has-icon btn-primary my-0"
        [disabled]="!canEnterEditMode"
        title="Copy this form revision tax year to another form revision tax year."
        type="button"
        (click)="copyTaxYear()">
    <i class="fa fa-clone"></i>
</button>
